import { render, staticRenderFns } from "./TkRadio.vue?vue&type=template&id=3561e205&"
import script from "./TkRadio.vue?vue&type=script&lang=js&"
export * from "./TkRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports